import ort from "onnxruntime-web";
var web_default = ort;
const target = "web";
export * from "onnxruntime-web";
export {
  web_default as default,
  target
};
//# sourceMappingURL=web.mjs.map
